import { Box } from '../Base';

const Container = (props): JSX.Element => {
  return <Box maxWidth={{ _: 'none', md: 1200 }} m="0 auto" width={1} px={4} {...props} />;
};

export default Container;
